module.exports = __webpack_public_path__ + "static/media/phone-blue.b794d2ba.svg";